module.exports = __webpack_public_path__ + "static/media/private_secure.738e56a1.png";